import React from "react";
import ContentBox from "../../components/molecules/ContentBox.Component";
import ImageSvg from "../../components/atoms/ImageSVG";
import { HashLink } from "react-router-hash-link";

const ProjectsMobile = ({ screen, lang, title, projects, tags }) => {
  return (
    <div className="w-full h-full pb-16">
      <div className="px-10 pt-10">
        <ContentBox
          tags={tags[lang]}
          title={{
            value: title.value[lang],
            style: "text-dark font-bold text-5xl",
          }}
          par={{ value: "", style: "" }}
        />
      </div>

      <div className="px-5 md:px-10 mt-8 flex flex-col gap-6">
        {projects.map((project, index) => (
          <article
            key={index}
            data-aos="fade-up"
            data-aos-delay={100}
            className="bg-[#eee] rounded-xl overflow-hidden shadow-xl"
          >
            <div
              className="w-full flex items-center justify-center h-40 md:h-56 bg-dark bg-no-repeat bg-cover bg-center"
              style={{ backgroundImage: `url(${project.media.src})` }}
              title={project.media.title}
              role="img"
              aria-label={project.media.alt}
            >
              <ImageSvg
                type={project.logo}
                fill={"#f6f6f6"}
                stroke={"#f6f6f6"}
                width={screen < 768 ? "25%" : "20%"}
              />
            </div>

            <div className="p-6">
              <h3 className="text-dark text-xl md:text-2xl font-bold">
                {project.title.value[lang]}
              </h3>

              {project.tags && project.tags[lang].length ? (
                <div className="mt-2 flex flex-wrap gap-2">
                  {project.tags[lang].map((tag, i) => (
                    <span
                      key={i}
                      className="bg-dark text-light text-xs font-bold capitalize px-3 py-1 rounded"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              ) : null}

              <p className="mt-3 text-sm leading-relaxed text-dark-33">
                {project.par.value[lang]}
              </p>

              {project.par.list ? (
                <ol className="list-decimal ml-5 mt-3 font-semibold">
                  {project.par.list.value[lang].map((list, i) => (
                    <li key={i} role="region" className="text-sm py-0.5">
                      {list}
                    </li>
                  ))}
                </ol>
              ) : null}

              {project.button ? (
                <HashLink
                  to={project.button.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={project.title.value[lang]}
                >
                  <p className="mt-5 w-fit cursor-pointer bg-light px-4 py-1 rounded shadow-xl transition-all duration-300 ease-in-out hover:bg-blue-500 hover:text-light hover:fill-[#f6f6f6]">
                    <span className="text-lg">
                      {project.button.value[lang]}
                    </span>
                    <span className="float-right relative top-1.5 ml-3">
                      <ImageSvg type="east" width={25} />
                    </span>
                  </p>
                </HashLink>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default ProjectsMobile;
